import React, { useContext, useEffect, useState } from "react";
import { firestore } from "../firebase.config";
import { DataContext } from "../Context/DataContext";

const MessageDot = ({chatId, type="general", color= "#18b7bb"}) => {
  const { userData } = useContext(DataContext);
  const [showMessageDot, setShowMessageDot] = useState(false);

  // general chat message dot
  useEffect(() => {
    let unsub;
    if (chatId) {
      unsub = firestore
        .collection(type === "everbary"? "everbarychats" :"chats")
        .doc(chatId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            const data = doc.data();
            const messages = Array.isArray(data?.messages) ? data.messages : [];
            const unReadMessages = messages.filter(
              (m) => m.senderId !== userData.id && m.unRead === true
            );
            if (unReadMessages && unReadMessages.length > 0) {
              setShowMessageDot(true);
            } else {
              setShowMessageDot(false);
            }
          }
        });
    }
    return () => unsub && unsub();
  }, [chatId, userData, type]);


  return showMessageDot ? <div className="chatDot" style={{backgroundColor: type ==="everbary" ? "#F299B3" : color}}></div> : <></>;
};

export default MessageDot;
